import { graphql } from 'react-relay';
import { useState, useEffect } from 'react';
import type {
	useLabelsLabelCountQuery as useLabelsLabelCountQuery$data,
	useLabelsLabelCountQueryVariables as useLabelsLabelCountQuery$variables,
} from './__types__/useLabelsLabelCountQuery.ts';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useLabels = (contentId: string): boolean => {
	const [hasLabels, setHasLabels] = useState<boolean>(true);
	const { data } = useQueryInterop<
		useLabelsLabelCountQuery$data,
		useLabelsLabelCountQuery$variables
	>(
		graphql`
			query useLabelsLabelCountQuery($contentId: ID!) {
				content(id: $contentId, status: ["current", "draft"]) {
					nodes {
						id
						labels(orderBy: { sortField: LABELLING_CREATIONDATE, direction: ASCENDING }) {
							count
						}
					}
				}
			}
		`,
		{
			variables: { contentId },
		},
	);

	useEffect(() => {
		setHasLabels((data?.content?.nodes?.[0]?.labels?.count ?? 0) > 0);
	}, [data]);

	return hasLabels;
};
